import React from "react";
import { useI18n } from "../lib/i18n";
import { Globe } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export default function LanguageSwitch({ variant = "sidebar" }) {
  const { lang, setLang } = useI18n();
  const dark = variant === "sidebar";
  return (
    <div className="flex items-center gap-2" data-testid="language-switch">
      <Globe className={`w-4 h-4 ${dark ? "text-slate-400" : "text-slate-500"}`} />
      <Select value={lang} onValueChange={setLang}>
        <SelectTrigger
          className={`h-8 w-[130px] text-xs ${dark ? "bg-transparent border-slate-700 text-slate-200 hover:bg-slate-800" : ""}`}
          data-testid="language-select-trigger"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="en" data-testid="lang-en">English</SelectItem>
          <SelectItem value="ta" data-testid="lang-ta">தமிழ் (Tamil)</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
